import CreateHistory from "history/createHashHistory";

// this class abstracts the setting and geting of the URL in the browser
// it handles the getters out of the current URL
// the setters will change the URL and can impact other params as wel:
// page --> only changes the page-number
// publicationId --> sets the page to the default page number
// contentpackageId --> sets the publicationId to undefined and pageId to undefined
// prefered --> only changes the prefered
export default class URLRouter {
  history = undefined;
  options = {};
  _page = undefined;
  _cpid = undefined;
  _pubid = undefined;
  _prefered = undefined;
  _contentid = undefined;

  constructor(options = { default_pagenubmer: 0, prefered: 0 }) {
    this.options = options;
    const hash = location.hash.toString();
    if (
      hash &&
      hash.length > 1 &&
      hash.charAt(0) == "#" &&
      hash.charAt(1) != "!"
    ) {
      location.hash =
        hash.substring(0, 1) + "!" + hash.substring(1, hash.length);
    }
    this.history = new CreateHistory({
      hashType: "hashbang", // Google's legacy AJAX URL format
    });
  }

  get page() {
    this.parseLocation();
    return this._page;
  }

  set page(value) {
    if (this._page !== value) {
      this._page = value;
      this.setLocation();
    }
  }

  get contentid() {
    this.parseLocation();
    return this._contentid;
  }
  set contentid(value) {
    if (this._contentid !== value) {
      this._contentid = value;
      this.setLocation();
    }
  }

  get publicationId() {
    this.parseLocation();
    return this._pubid;
  }

  get contentpackageId() {
    this.parseLocation();
    return this._cpid;
  }

  get prefered() {
    this.parseLocation();
    return this._prefered;
  }

  updateLocation(
    cp,
    pub,
    page,
    prefered,
    contentid = undefined,
    replace = false
  ) {
    if (
      this._page !== page ||
      this._cpid !== cp ||
      this._pubid !== pub ||
      this._prefered !== prefered ||
      this._contentid !== contentid
    ) {
      this._page = page;
      this._cpid = cp;
      this._pubid = pub;
      this._prefered = prefered;
      this._contentid = contentid;
      this.setLocation(replace);
    }
  }

  listen(fnc) {
    this.history.listen(fnc);
  }

  // private methods

  setLocation(replace = false) {
    const alb = this._contentid ? `/alb/${this._contentid}` : "";
    const location = `!preferred/${this._prefered}/package/${this._cpid}/pub/${this._pubid}/page/${this._page}${alb}`;
    if (location.indexOf("undefined") !== -1) return;
    if (replace) {
      this.history.replace(location);
    } else {
      this.history.push(location);
    }
  }

  parseLocation() {
    // Get the current location.
    const location = this.history.location.pathname;
    if (!isNaN(location)) {
      this._page = undefined;
      this._cpid = parseInt(location, 10);
      this._pubid = undefined;
      this._prefered = undefined;
    } else {
      // try to parse out all the rest;
      // it should be this syntax preferred/PREFERENCE/package/CPID/pub/PUBID/page/PAGENR
      const regexToMatch =
        /[?.*#!p|p]referred\/(.*)\/package\/(.*)\/pub\/(.*)\/page\/(.*)/g;
      const regexToMatchAlb =
        /[?.*#!p|p]referred\/(.*)\/package\/(.*)\/pub\/(.*)\/page\/(.*)\/(?:alb|content)\/(.*)/g;
      const match = regexToMatch.exec(location);
      const matchAlb = regexToMatchAlb.exec(location);
      if (matchAlb) {
        this._prefered = parseInt(matchAlb[1], 10);
        this._cpid = parseInt(matchAlb[2], 10);
        this._pubid = parseInt(matchAlb[3], 10);
        this._page = parseInt(matchAlb[4], 10);
        this._contentid = parseInt(matchAlb[5], 10);
        URLRouter.page = this._page;
      } else if (match) {
        this._prefered = parseInt(match[1], 10);
        this._cpid = parseInt(match[2], 10);
        this._pubid = parseInt(match[3], 10);
        this._page = parseInt(match[4], 10);
        this._contentid = undefined;
        URLRouter.page = this._page;
      } else {
        this._page = undefined;
        this._cpid = undefined;
        this._pubid = undefined;
        this._prefered = undefined;
        this._contentid = undefined;
      }
    }
  }

  static isAlbURL() {
    const albRegex = /(?:alb|content)/g;
    return window.location.href.search(albRegex) !== -1;
  }
}



// WEBPACK FOOTER //
// ./src/common/utilities/URLRouter.js